import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View } from 'dripsy';
import React, { useContext } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';

import { ModalView } from '@/design-system/components/modal/ModalView';
import { UniNativeModal } from '@/design-system/components/modal/nativeModal/UniNativeModal';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { ViewAllCardWebScreen } from './ViewAllCardWeb.screen';

export interface ViewAllCardProps {}
export const ViewAllCardScreen: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.ViewAllCard>> = ({
  navigation
}) => {
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  if (layout.isMobile) {
    return (
      <View sx={stylesNative.containerNative}>
        <UniNativeModal onBack={onGoBack} showHeader={false}>
          view all card mobile
        </UniNativeModal>
      </View>
    );
  }

  const { useModalProps, closeModal } = useModalView({});
  return (
    <ModalView useModalProps={useModalProps} minWidth={500}>
      <ViewAllCardWebScreen onClose={closeModal} />
    </ModalView>
  );
};

enum StyleNameNative {
  containerNative = 'containerNative'
}

const stylesNative: Record<StyleNameNative, SxProp> = {
  containerNative: {
    flex: 1,
    height: '100%',
    backgroundColor: 'transparent'
  }
};
